import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT || process.env.RAILS_ENV,
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      // Matches the applicationKey in sentryWebpackPlugin configuration.
      filterKeys: ['fujifilm-frontend'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],

  // Capture user context if available
  beforeSend(event) {
    const userId = document.querySelector('meta[name="current-user-id"]')?.content;

    if (userId) {
      event.user = {
        id: userId
      };
    }

    return event;
  }
});
